import baseApi from "../api/baseApi";

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPublicCourses: builder.query({
      query: () => ({
        url: "/public/courses",
        method: "GET",
      }),
    }),
    registerStudent: builder.mutation({
      query: (studentData) => ({
        url: "/auth/register/student",
        method: "POST",
        body: studentData,
      }),
    }),
    registerInstructor: builder.mutation({
      query: (instructorData) => ({
        url: "/auth/register/instructor",
        method: "POST",
        body: instructorData,
      }),
    }),
    verifyEmailAddress: builder.mutation({
      query: (payload) => ({
        url: "/auth/verifyEmailAddress",
        method: "POST",
        body: payload,
      }),
    }),
    loginUser: builder.mutation({
      query: (payload) => ({
        url: "/auth/login/users",
        method: "POST",
        body: payload,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (payload) => ({
        url: "/auth/forgotPassword",
        method: "POST",
        body: payload,
      }),
    }),
    verifyInitialOtp: builder.mutation({
      query: (payload) => ({
        url: "/auth/verifyInitialOtp",
        method: "POST",
        body: payload,
      }),
    }),
    resetPasswordWithOtp: builder.mutation({
      query: (payload) => ({
        url: "/auth/resetPasswordWithOtp",
        method: "POST",
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetPublicCoursesQuery,
  useRegisterStudentMutation,
  useRegisterInstructorMutation,
  useVerifyEmailAddressMutation,
  useLoginUserMutation,
  useForgotPasswordMutation,
  useVerifyInitialOtpMutation,
  useResetPasswordWithOtpMutation,
} = authApi;